import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";

/**
 * 🔹 Payload para crear/actualizar
 */
export interface RequisitosDesplazamientosPayload {
  descripcion: string;
  estado?: number;
}

/**
 * 🔹 Entidad
 */
export interface RequisitosDesplazamientos {
  id?: number;
  descripcion: string;
  estado: number;
  fechaCreacion?: string;
  fechaModificacion?: string;
}

/**
 * 🔹 Respuesta genérica
 */
export interface RequisitosDesplazamientosResponse {
  id?: number;
  message?: string;
  error?: string;
  data?: any;
  [key: string]: any;
}

@Injectable({
  providedIn: "root",
})
export class RequisitosDesplazamientosService {
  private readonly apiUrl =
    `${environment.apiUrl}/api/requisitos_desplazamientos`;

  constructor(private http: HttpClient) {}

  /**
   * Obtener todos los requisitos de desplazamiento
   */
  getAll(): Observable<RequisitosDesplazamientos[]> {
    return this.http.get<RequisitosDesplazamientos[]>(
      this.apiUrl,
      {
        withCredentials: true,
      }
    );
  }

  /**
   * Obtener requisito de desplazamiento por ID
   */
  getById(id: number): Observable<RequisitosDesplazamientos> {
    return this.http.get<RequisitosDesplazamientos>(
      `${this.apiUrl}/${id}`,
      {
        withCredentials: true,
      }
    );
  }

  /**
   * Crear requisito de desplazamiento
   */
  create(
    payload: RequisitosDesplazamientosPayload
  ): Observable<RequisitosDesplazamientosResponse> {
    return this.http.post<RequisitosDesplazamientosResponse>(
      this.apiUrl,
      payload,
      {
        withCredentials: true,
      }
    );
  }

  /**
   * Actualizar requisito de desplazamiento
   */
  update(
    id: number,
    payload: Partial<RequisitosDesplazamientosPayload>
  ): Observable<RequisitosDesplazamientosResponse> {
    return this.http.put<RequisitosDesplazamientosResponse>(
      `${this.apiUrl}/${id}`,
      payload,
      {
        withCredentials: true,
      }
    );
  }

  /**
   * Eliminar requisito de desplazamiento
   */
  remove(id: number): Observable<any> {
    return this.http.delete<any>(
      `${this.apiUrl}/${id}`,
      {
        withCredentials: true,
      }
    );
  }

  /**
   * Inactivar requisito de desplazamiento
   */
  inactivar(
    id: number
  ): Observable<RequisitosDesplazamientosResponse> {
    return this.http.put<RequisitosDesplazamientosResponse>(
      `${this.apiUrl}/${id}/inactivar`,
      {},
      {
        withCredentials: true,
      }
    );
  }

  /**
   * Activar requisito de desplazamiento
   */
  activar(
    id: number
  ): Observable<RequisitosDesplazamientosResponse> {
    return this.http.put<RequisitosDesplazamientosResponse>(
      `${this.apiUrl}/${id}/activar`,
      {},
      {
        withCredentials: true,
      }
    );
  }
}